const employeesData = [
  {
    id: 1,
    fullName: "Gagan Rawat",
    position: "Developer",
    email: "gagan143@gmail.com",
    salary: "95000",
    date: "2019-04-11",
  },
  {
    id: 2,
    fullName: "Adrienne",
    position: "SEO",
    email: "adrienne@example.com",
    salary: "80000",
    date: "2019-04-17",
  },
  {
    id: 3,
    fullName: "Rolf",
    position: "junior Devloper",
    email: "rolf@example.com",
    salary: "79000",
    date: "2019-05-01",
  },
];

export { employeesData };
